import { render, staticRenderFns } from "./CertificateTemplatePreview.vue?vue&type=template&id=ccf1986c&scoped=true"
import script from "./CertificateTemplatePreview.vue?vue&type=script&lang=js"
export * from "./CertificateTemplatePreview.vue?vue&type=script&lang=js"
import style0 from "./CertificateTemplatePreview.vue?vue&type=style&index=0&id=ccf1986c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ccf1986c",
  null
  
)

export default component.exports